export const GET_DEVICE_LOG = "GET_DEVICE_LOG";
export const SET_SELECTED_TIME = "SET_SELECTED_TIME";
export const CLEAR_SELECTED_TIME = "CLEAR_SELECTED_TIME";
export const SET_SELECTED_MARKER = "SET_SELECTED_MARKER";

export const SET_SELECTED_PACKAGE_TIME = "SET_SELECTED_PACKAGE_TIME";
export const CLEAR_SELECTED_PACKAGE_TIME = "CLEAR_SELECTED_PACKAGE_TIME";

export const GET_DEVICE_LOG_DEBUG_TEST = "GET_DEVICE_LOG_DEBUG_TEST";